import { render, staticRenderFns } from "./VerificationEmailCodeForm.vue?vue&type=template&id=2871afa4&"
import script from "./VerificationEmailCodeForm.vue?vue&type=script&lang=js&"
export * from "./VerificationEmailCodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports